(function () {
  // Optional: close other tabs when one opens (accordion behavior).
  // Comment out the block below if you want independent tabs.
  document.querySelectorAll('[data-tabs]').forEach((root) => {
    const items = Array.from(root.querySelectorAll('.ls-ptabs__item'));
    items.forEach((d) => {
      d.addEventListener('toggle', () => {
        if (!d.open) return;
        items.forEach((other) => { if (other !== d) other.open = false; });
      });
    });
  });
})();
